var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "findPassWord" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": _vm.isShow,
          "title-mb": "密码找回",
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c(
        "div",
        { staticClass: "formClass" },
        [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$isFlag,
                  expression: "$isFlag"
                }
              ],
              staticStyle: {
                color: "#626fdd",
                "font-size": "0.28rem",
                "margin-bottom": "0.1rem",
                "text-align": "right",
                position: "relative"
              },
              on: { click: _vm.forgetAccount }
            },
            [_vm._v(" 忘记账号？ ")]
          ),
          _c(
            "van-form",
            [
              _c("van-field", {
                staticClass: "field",
                attrs: {
                  label: "账号名",
                  placeholder: "请填写您的雷霆账号",
                  rules: [{ required: true, message: "不可为空" }]
                },
                model: {
                  value: _vm.username,
                  callback: function($$v) {
                    _vm.username = $$v
                  },
                  expression: "username"
                }
              }),
              _c(
                "div",
                [
                  _c("div", {
                    staticClass: "entry captcha",
                    attrs: { id: "ltCaptchaLogin" }
                  }),
                  _c(
                    "van-checkbox",
                    {
                      staticClass: "checkbox",
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _vm._v("我已阅读并同意 "),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#626fdd" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.ltUserRule($event)
                            }
                          }
                        },
                        [_vm._v("《雷霆游戏用户隐私政策》")]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "#626fdd" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.ltGameRule($event)
                            }
                          }
                        },
                        [_vm._v("《雷霆游戏用户协议》")]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            color: "#616edf"
                          },
                          on: { click: _vm.onSubmitOne }
                        },
                        [_vm._v("下一步")]
                      ),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.$isFlag,
                              expression: "!$isFlag"
                            }
                          ],
                          staticStyle: {
                            color: "#626fdd",
                            "font-size": "0.28rem",
                            margin: "0.4rem 0",
                            "text-align": "center",
                            cursor: "pointer"
                          },
                          on: { click: _vm.forgetAccount }
                        },
                        [_vm._v(" 忘记账号？ ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }